import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import {
  lightBlue,
} from "@mui/material/colors";

export const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    marginBottom: 16,
  },
  subtitle: {
    marginBottom: 24,
  },
  infoBanner: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    borderRadius: 4,
    padding: "16px",
    marginBottom: 24,
    backgroundColor:
      theme.palette.mode === "dark"
        ? lightBlue[900]
        : lightBlue[50],
  },
  infoBannerIcon: {
    color: 
      theme.palette.mode === "dark"
        ? lightBlue[50]
        : lightBlue[900],
  },
  infoBannerText: {
    color: 
    theme.palette.mode === "dark"
      ? lightBlue[50]
      : lightBlue[900],
  },
  sectionLabel: {
    marginBottom: 8,
  },
  checkboxLabel: {
    alignItems: "baseline",
    display: "inline-flex",
    gap: 8,
  },
  checkboxRow: { marginBottom: 16 },
    divider: {
      height: 1,
      backgroundColor: theme.palette.divider,
      margin: "24px 0",
    },
  tooltipIconWrap: {
    display: "inline-flex",
  },
  dateRow: {
    display: "flex",
    gap: 16,
    "@media (max-width: 767px)": {
      flexWrap: "wrap",
      gap: 0,
    },
  },
  actions: {
    marginTop: 16,
  },
  footerNote: {
    marginTop: 16,
  },
}));
